import { FieldTypeV1 } from '@gsc/types'
import { Event, EventType } from './event'
import { EventContext } from './event-context'

interface SparkLoop {
  trackSubscriber: (email: string) => void
}

export function track() {
  return (events: Event[], ctx: EventContext) => {
    const SL: SparkLoop = (window as any)['SL']
    if (!SL?.trackSubscriber) {
      return
    }

    const submitEvent = events.find(e => e.type === EventType.SubmitWidget)
    if (!submitEvent) {
      return
    }

    // TODO: Sparkloop integration
    // const data = submitEvent.getData()
    // const fields = (submitEvent.widget?.pages || []).flatMap(p => p.data?.fields || [])
    // const emails = fields.filter(f => f.type === FieldType.Email).map(f => data[f.name])

    // emails.forEach(e => SL.trackSubscriber(e))
  }
}
